import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FileIcon from "../../UI/FileIcon/FileIcon";
import { AttachmentSourceMapping } from "../../../Domain/PersonDocument/AttachmentSource.enum";
const DocumentLink = (props) => {
    if (props.personDocument.sourceIntegrationId === AttachmentSourceMapping.Native) {
        return (_jsxs("a", { href: "/aviso/advisor/readDocument/" + props.personDocument.fileId, children: [_jsx(FileIcon, { extension: props.personDocument.fileExtension, addMarginRight: true }), props.personDocument.description] }));
    }
    return (_jsxs("a", { 
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
        href: props.personDocument.externalUrl, target: "_blank", rel: "noopener noreferrer", children: [_jsx(FileIcon, { extension: props.personDocument.fileExtension, addMarginRight: true }), props.personDocument.description] }));
};
export default DocumentLink;
